<template>
    <div class="interview-source">
        <div class="muted-text">{{$t('source.you_can_offer_an_interview_in_one_of_two_ways')}}</div>

        <ol class="interview-source-steps">
            <li class="interview-source-step">{{$t('source.if_you_have_conducted_the_interview_yourself_add_this_as_an_appendix_and_refer_to_this_appendix_in_the_text')}}</li>
            <li class="interview-source-step">{{$t('source.if_you_use_the_interview_of_someone_else_you_can_reference_it_according_to_the_normal_rules_for_example_when_the_interview_is_on_a_website_or_in_a_newspaper_article')}}</li>
        </ol>
    </div>
</template>

<script>
    export default {
        name: "design-2021-source-interview-form",
        props: ['projectId'],
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>
